// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jl-bg {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7fbff 0%, #f4f7fb 100%);
  overflow-x: clip;
}
.jl-bg,
.jl-bg *,
.jl-bg *::before,
.jl-bg *::after {
  box-sizing: border-box;
}

.jl-container {
  max-width: 1380px;
  margin: 0 auto;
  padding: 28px 24px 48px;
}

.jl-page-shell {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.jl-page-shell--status {
  gap: 20px;
}

.jl-page-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 8px 0 4px;
}

.jl-page-head--compact {
  align-items: center;
  justify-content: flex-end;
  padding: 0;
  min-height: 20px;
}

.jl-page-head--status {
  align-items: flex-start;
}

.jl-page-kicker {
  margin: 0 0 10px;
  color: #0f9f97;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.jl-page-title {
  margin: 0;
  color: #0f172a;
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 800;
  line-height: 1.08;
  max-width: 760px;
}

.jl-page-subtitle {
  margin: 12px 0 0;
  max-width: 760px;
  color: #64748b;
  font-size: 15px;
  line-height: 1.7;
}

.jl-result-count {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  white-space: nowrap;
}

.jl-inline-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid #d7e7f4;
  border-radius: 14px;
  background: #f8fbff;
  color: #355070;
}
.jl-inline-notice svg {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: 16px;
}
.jl-inline-notice p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.jsb-wrap {
  background: #fff;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  margin-bottom: 0;
  position: sticky;
  top: 76px;
  z-index: 20;
}

.jsb-inner {
  max-width: 1380px;
  margin: 0 auto;
  padding: 18px 24px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(220px, 280px) auto;
  gap: 14px;
  align-items: center;
}

.jsb-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.jsb-input-icon {
  position: absolute;
  left: 16px;
  color: #94a3b8;
  font-size: 17px;
  pointer-events: none;
}

.jsb-input {
  width: 100%;
  height: 54px;
  padding: 0 18px 0 46px;
  border: 1px solid #d9e2ec;
  border-radius: 14px;
  background: #fff;
  color: #0f172a;
  font-size: 15px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.jsb-input:focus {
  border-color: #2ec4b6;
  box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);
}

.city-dd {
  position: relative;
}
.city-dd__control {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 54px;
  padding: 0 14px;
  border: 1px solid #d9e2ec;
  border-radius: 14px;
  background: #fff;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.city-dd__control:focus-within {
  border-color: #2ec4b6;
  box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);
}
.city-dd__icon {
  color: #94a3b8;
  font-size: 16px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
}
.city-dd__input {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 14px;
  color: #0f172a;
  background: transparent;
}
.city-dd__input::placeholder {
  color: #9aa8b7;
}
.city-dd__clear, .city-dd__arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  padding: 0;
  flex: 0 0 auto;
}
.city-dd__clear {
  font-size: 14px;
}
.city-dd__arrow {
  font-size: 15px;
  transition: transform 0.2s ease;
}
.city-dd__arrow--open {
  transform: rotate(180deg);
}
.city-dd__menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  max-height: 280px;
  overflow-y: auto;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #d9e2ec;
  border-radius: 14px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.14);
  z-index: 30;
}
.city-dd__item {
  padding: 10px 14px;
  color: #334155;
  font-size: 14px;
  cursor: pointer;
}
.city-dd__item:hover {
  background: #f0fdfa;
}
.city-dd__item--active {
  background: #e6fffb;
  color: #0f766e;
  font-weight: 700;
}
.city-dd__empty {
  padding: 12px 14px;
  color: #94a3b8;
  font-size: 13px;
  text-align: center;
}

.jsb-btn {
  height: 54px;
  padding: 0 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #17b9af 0%, #109d95 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}
.jsb-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(23, 185, 175, 0.26);
}
.jsb-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.jl-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  align-items: stretch;
  min-width: 0;
}

.job-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  min-width: 0;
  width: 100%;
  padding: 20px;
  border: 1px solid #dce7ef;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}
.job-card:hover {
  transform: translateY(-2px);
  border-color: #c9dbe6;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);
}
.job-card--compact {
  align-self: start;
  gap: 8px;
}
.job-card--compact .job-card__content {
  flex: 0 1 auto;
  gap: 6px;
}
.job-card--compact .job-card__footer {
  padding-top: 6px;
}
.job-card__content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
}
.job-card__header {
  min-height: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}
.job-card__title {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.28;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}
.job-card__location, .job-card__posted, .job-card__meta-item {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.55;
  min-width: 0;
}
.job-card__location svg, .job-card__posted svg, .job-card__meta-item svg {
  flex: 0 0 auto;
  font-size: 14px;
}
.job-card__location span, .job-card__posted span, .job-card__meta-item span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.job-card__salary {
  margin: 0;
  color: #f59e0b;
  font-size: 21px;
  font-weight: 800;
  line-height: 1.2;
}
.job-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  min-width: 0;
}
.job-card__type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}
.job-card__type-badge--teal {
  background: #dff8f5;
  color: #0f766e;
}
.job-card__type-badge--amber {
  background: #fff4d6;
  color: #b45309;
}
.job-card__type-badge--slate {
  background: #eef2f7;
  color: #475569;
}
.job-card__footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 6px;
  border-top: 1px solid #edf2f7;
  min-width: 0;
}
.job-card__detail-link {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  color: #0f9f97;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.job-card__detail-link:hover {
  color: #0d817b;
}
.job-card__applied-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 7px 11px;
  border-radius: 999px;
  background: #e7fbf3;
  color: #166534;
  border: 1px solid #b7efcd;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.job-card--skeleton {
  pointer-events: none;
  min-height: 238px;
}
.job-card--skeleton .skeleton {
  background: linear-gradient(90deg, #eef2f7 25%, #e4eaf1 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 10px;
}
.job-card--skeleton .skeleton--title {
  height: 24px;
  width: 70%;
}
.job-card--skeleton .skeleton--text {
  height: 14px;
  width: 92%;
}
.job-card--skeleton .skeleton--short {
  width: 56%;
}
.job-card--skeleton .skeleton--badge {
  height: 34px;
  width: 120px;
  border-radius: 999px;
}
.job-card--skeleton .skeleton-row {
  display: flex;
  gap: 10px;
}

.jl-list-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 10px 0 0;
}

.jl-load-sentinel {
  width: 100%;
  height: 1px;
  pointer-events: none;
}

.jl-list-footer__loading,
.jl-list-footer__end,
.jl-list-footer__error {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 14px;
  font-size: 14px;
}

.jl-list-footer__complete {
  display: flex;
  align-items: center;
  justify-content: center;
}

.jl-list-footer__loading {
  color: #0f766e;
  background: #e8fffa;
  border: 1px solid #c8f6ed;
}

.jl-list-footer__end {
  color: #64748b;
  padding: 0;
  background: transparent;
  border: none;
}

.jl-list-footer__error {
  color: #9f1239;
  background: #fff1f4;
  border: 1px solid #fecdd3;
  flex-wrap: wrap;
  justify-content: center;
}
.jl-list-footer__error button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  color: #be123c;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.jl-back-to-top {
  position: fixed;
  right: 28px;
  bottom: 124px;
  z-index: 25;
  width: 46px;
  height: 46px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: #0f9f97;
  color: #fff;
  box-shadow: 0 12px 28px rgba(15, 118, 110, 0.3);
  font-size: 23px;
  cursor: pointer;
  transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}
.jl-back-to-top:hover {
  background: #0d817b;
  box-shadow: 0 16px 34px rgba(15, 118, 110, 0.38);
  transform: translateY(-4px);
}
.jl-back-to-top:focus-visible {
  outline: 2px solid #2ec4b6;
  outline-offset: 3px;
}

.jl-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 300px;
  padding: 36px 28px;
  border: 1px solid #dce7ef;
  border-radius: 22px;
  background: #fff;
  text-align: center;
}
.jl-state svg {
  font-size: 40px;
  color: #0f9f97;
}
.jl-state p {
  margin: 0;
  color: #334155;
  font-size: 16px;
  line-height: 1.65;
  max-width: 720px;
}
.jl-state .jl-state__sub {
  color: #64748b;
  font-size: 14px;
}
.jl-state button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
  min-height: 46px;
  padding: 0 18px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #17b9af 0%, #109d95 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.jl-state--error {
  background: #fff9fa;
}
.jl-state--error svg {
  color: #e11d48;
}

.jl-state--loading svg {
  color: #0f9f97;
}

.jl-status {
  border: 1px solid #dbe7f0;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.jl-status__header {
  padding: 24px 28px 18px;
  border-bottom: 1px solid #e8eff5;
  background: linear-gradient(180deg, #fcfffe 0%, #f8fbff 100%);
}

.jl-status__header-title {
  margin: 0 0 4px;
  color: #0f172a;
  font-size: 22px;
  font-weight: 800;
}

.jl-status__count {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.jl-status__table-wrap {
  padding: 22px 28px 28px;
}

.jl-status__filters {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  gap: 12px;
  align-items: end;
  padding: 16px;
  margin-bottom: 18px;
  border: 1px solid #e6edf3;
  border-radius: 18px;
  background: #fbfdfe;
}

.jl-status-filter {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.jl-status-filter label {
  margin: 0;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.jl-status-filter select,
.jl-status-filter input {
  height: 46px;
  padding: 0 14px;
  border: 1px solid #dbe4ea;
  border-radius: 12px;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.jl-status-filter select:focus,
.jl-status-filter input:focus {
  border-color: #2ec4b6;
  box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);
}

.jl-status-filter__calendar-trigger {
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 14px;
  border: 1px solid #dbe4ea;
  border-radius: 12px;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.jl-status-filter__calendar-trigger:focus, .jl-status-filter__calendar-trigger:focus-visible {
  border-color: #2ec4b6;
  box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);
}

.jl-status-filter__calendar-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.jl-status-filter__calendar-caret {
  color: #94a3b8;
  font-size: 15px;
}

.jl-status__reset-filter {
  height: 46px;
  padding: 0 16px;
  border: 1px solid #d7e7f4;
  border-radius: 12px;
  background: #f8fbff;
  color: #0f766e;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.jl-status__reset-filter:hover {
  border-color: #99d9d3;
  background: #eefbf9;
}
.jl-status__reset-filter svg {
  flex: 0 0 auto;
  font-size: 15px;
}

.jl-status__guest {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  padding: 32px;
  text-align: center;
}
.jl-status__guest h3 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
}
.jl-status__guest p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
  max-width: 640px;
}

.jl-status__guest--filtered {
  border: 1px dashed #cbd5e1;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfdfe 0%, #f8fafc 100%);
}

.jl-status__guest-icon {
  margin-bottom: 12px;
}
.jl-status__guest-icon svg {
  font-size: 40px;
  color: #0f9f97;
}

.jl-app-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.jl-app-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: stretch;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}

.jl-app-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-width: 0;
  padding: 14px 16px;
}

.jl-app-card__title-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.jl-app-card__headline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.jl-app-card__title {
  margin: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.3;
}

.jl-app-card__meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.jl-app-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.35;
}
.jl-app-card__meta-item svg {
  flex: 0 0 auto;
}

.jl-app-card__side {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 260px;
}

.jl-status__badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.jl-status__badge--success {
  background: #e7fbf3;
  color: #166534;
  border: 1px solid #b7efcd;
}

.jl-status__badge--info {
  background: #e9f3ff;
  color: #1d4ed8;
  border: 1px solid #bfd9ff;
}

.jl-status__badge--danger {
  background: #fff1f4;
  color: #be123c;
  border: 1px solid #fecdd3;
}

.jl-status__badge--warning {
  background: #fff7e4;
  color: #b45309;
  border: 1px solid #fde68a;
}

.jl-app-card__ai {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 16px 14px 0;
  background: transparent;
}

.jl-app-card__ai-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.jl-app-card__ai-title {
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
}

.jl-app-card__ai-desc,
.jl-app-card__ai-meta-row {
  color: #64748b;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
}

.jl-app-card__ai-cta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.jl-iv-flow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.jl-iv-flow--not_started {
  background: #fff7e4;
  color: #b45309;
  border: 1px solid #fde68a;
}

.jl-iv-flow--in_progress {
  background: #e9f3ff;
  color: #1d4ed8;
  border: 1px solid #bfd9ff;
}

.jl-iv-flow--completed {
  background: #e7fbf3;
  color: #166534;
  border: 1px solid #b7efcd;
}

.jl-iv-btn {
  min-height: 38px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.jl-iv-btn--start {
  background: linear-gradient(135deg, #17b9af 0%, #109d95 100%);
  color: #fff;
  box-shadow: 0 10px 22px rgba(23, 185, 175, 0.2);
}

.jl-iv-btn--resume {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  box-shadow: 0 10px 22px rgba(59, 130, 246, 0.2);
}

.jl-iv-btn--detail {
  border: 1px solid #c8d7e3;
  background: #fff;
  color: #0f172a;
}

.jl-iv-btn:hover {
  transform: translateY(-1px);
}

.jl-iv-result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.jl-iv-result__score-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.jl-iv-result__score {
  color: #0f172a;
  font-size: 15px;
  font-weight: 800;
  white-space: nowrap;
}

.jl-iv-result__badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  background: #edf4ff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.spin {
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes shimmer {
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
}
@media (max-width: 1260px) {
  .jl-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1120px) {
  .jsb-inner {
    grid-template-columns: minmax(0, 1fr) minmax(220px, 260px);
  }
  .jsb-btn {
    grid-column: 1/-1;
    width: 100%;
  }
  .jl-status__filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .jl-status__reset-filter {
    width: 100%;
  }
}
@media (max-width: 900px) {
  .jl-container {
    padding: 20px 16px 36px;
  }
  .jl-page-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .jl-app-card {
    grid-template-columns: 1fr;
  }
  .jl-app-card__header,
  .jl-app-card__ai-top,
  .jl-iv-result {
    flex-direction: column;
    align-items: flex-start;
  }
  .jl-app-card__side {
    justify-content: flex-start;
    min-width: 0;
  }
  .jl-app-card__ai {
    justify-content: flex-start;
    padding: 0 16px 14px;
  }
  .jl-app-card__ai-cta {
    justify-content: flex-start;
  }
}
@media (max-width: 820px) {
  .jsb-wrap {
    position: static;
    top: auto;
  }
  .jsb-inner {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
    padding: 14px 16px;
  }
  .jsb-input-wrap,
  .city-dd,
  .jsb-btn {
    width: 100%;
    min-width: 0;
  }
  .jsb-input,
  .city-dd__control,
  .jsb-btn {
    height: 50px;
  }
  .jsb-input {
    min-width: 0;
    text-overflow: ellipsis;
  }
  .jsb-btn {
    grid-column: auto;
  }
  .jl-container {
    padding-bottom: 126px;
    width: 100%;
    max-width: 100%;
  }
}
@media (max-width: 720px) {
  .jsb-inner {
    padding: 12px 16px;
  }
  .jl-grid {
    grid-template-columns: 1fr;
  }
  .jl-status__filters {
    grid-template-columns: 1fr;
    padding: 14px;
  }
  .jl-status__table-wrap,
  .jl-status__header {
    padding-left: 16px;
    padding-right: 16px;
  }
  .jl-app-card__header,
  .jl-app-card__ai {
    padding-left: 16px;
    padding-right: 16px;
  }
  .jl-app-card__ai {
    padding-top: 0;
  }
  .jl-back-to-top {
    right: 78px;
    bottom: 18px;
    width: 44px;
    height: 44px;
  }
}
@media (max-width: 560px) {
  .jl-container {
    padding: 16px 12px 126px;
  }
  .jl-page-title {
    font-size: 28px;
  }
  .job-card {
    min-height: 0;
    padding: 16px;
    gap: 10px;
    border-radius: 16px;
  }
  .job-card__content {
    gap: 8px;
  }
  .job-card__header {
    min-height: 0;
    gap: 10px;
  }
  .job-card__title,
  .jl-app-card__title {
    font-size: 18px;
  }
  .job-card__salary {
    font-size: 19px;
  }
  .job-card__meta {
    gap: 7px;
  }
  .job-card__type-badge {
    padding: 7px 10px;
  }
  .job-card__footer {
    gap: 10px;
  }
  .job-card__posted,
  .job-card__meta-item {
    font-size: 12px;
  }
  .job-card__posted {
    flex: 1 1 auto;
    min-width: 0;
  }
  .job-card__detail-link {
    flex: 0 0 auto;
    font-size: 13px;
  }
  .jl-list-footer__end {
    max-width: 100%;
    text-align: center;
    line-height: 1.5;
  }
}
@media (max-width: 360px) {
  .jsb-inner {
    padding: 10px;
  }
  .jsb-input {
    padding-left: 42px;
    padding-right: 12px;
    font-size: 14px;
  }
  .city-dd__control {
    padding-left: 12px;
    padding-right: 12px;
  }
  .jl-container {
    padding-left: 8px;
    padding-right: 8px;
  }
  .job-card {
    min-height: 0;
    padding: 14px;
  }
  .job-card__header {
    flex-direction: column;
    align-items: flex-start;
    min-height: 0;
  }
  .job-card__title {
    width: 100%;
    font-size: 17px;
  }
  .job-card__applied-badge {
    min-height: 30px;
    padding: 6px 9px;
    font-size: 11px;
  }
  .job-card__location {
    align-items: flex-start;
    font-size: 12px;
  }
  .job-card__salary {
    font-size: 18px;
  }
  .job-card__footer {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .job-card__detail-link {
    align-self: flex-end;
    min-height: 36px;
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/JobList.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,6DAAA;EACA,gBAAA;AACF;AACE;;;;EAIE,sBAAA;AACJ;;AAGA;EACE,iBAAA;EACA,cAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAAF;;AAGA;EACE,SAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAAF;AAEE;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAAJ;AAGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,8CAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,+DAAA;EACA,SAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;AAFF;AAIE;EACE,qBAAA;EACA,8CAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0DAAA;AAHJ;AAKI;EACE,qBAAA;EACA,8CAAA;AAHN;AAOE;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AALJ;AAQE;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AANJ;AAQI;EACE,cAAA;AANN;AAUE;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;AATJ;AAYE;EACE,eAAA;AAVJ;AAaE;EACE,eAAA;EACA,+BAAA;AAXJ;AAcE;EACE,yBAAA;AAZJ;AAeE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,WAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAdJ;AAgBI;EACE,mBAAA;AAdN;AAkBE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAjBJ;;AAqBA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2EAAA;AAlBF;AAoBE;EACE,2BAAA;EACA,gDAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;EACA,YAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,6DAAA;EACA,8CAAA;EACA,gFAAA;AApBF;AAsBE;EACE,2BAAA;EACA,qBAAA;EACA,6CAAA;AApBJ;AAuBE;EACE,iBAAA;EACA,QAAA;AArBJ;AAuBI;EACE,cAAA;EACA,QAAA;AArBN;AAwBI;EACE,gBAAA;AAtBN;AA0BE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AAzBJ;AA4BE;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AA1BJ;AA6BE;EAGE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AA7BJ;AA+BI;EACE,cAAA;EACA,eAAA;AA7BN;AAgCI;EACE,YAAA;EACA,uBAAA;AA9BN;AAkCE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAhCJ;AAmCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AAjCJ;AAoCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE,mBAAA;EACA,cAAA;AAnCJ;AAsCE;EACE,mBAAA;EACA,cAAA;AApCJ;AAuCE;EACE,mBAAA;EACA,cAAA;AArCJ;AAwCE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AAtCJ;AAyCE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAvCJ;AAyCI;EACE,cAAA;AAvCN;AA2CE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAzCJ;AA4CE;EACE,oBAAA;EACA,iBAAA;AA1CJ;AA4CI;EACE,yEAAA;EACA,0BAAA;EACA,gCAAA;EACA,mBAAA;AA1CN;AA6CI;EACE,YAAA;EACA,UAAA;AA3CN;AA8CI;EACE,YAAA;EACA,UAAA;AA5CN;AA+CI;EACE,UAAA;AA7CN;AAgDI;EACE,YAAA;EACA,YAAA;EACA,oBAAA;AA9CN;AAiDI;EACE,aAAA;EACA,SAAA;AA/CN;;AAoDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAjDF;;AAoDA;EACE,WAAA;EACA,WAAA;EACA,oBAAA;AAjDF;;AAoDA;;;EAGE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAjDF;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAjDF;;AAoDA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAjDF;;AAoDA;EACE,cAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AAjDF;;AAoDA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,uBAAA;AAjDF;AAmDE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAjDJ;;AAqDA;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,+CAAA;EACA,eAAA;EACA,eAAA;EACA,8EAAA;AAlDF;AAoDE;EACE,mBAAA;EACA,gDAAA;EACA,2BAAA;AAlDJ;AAqDE;EACE,0BAAA;EACA,mBAAA;AAnDJ;;AAuDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AApDF;AAsDE;EACE,eAAA;EACA,cAAA;AApDJ;AAuDE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AArDJ;AAwDE;EACE,cAAA;EACA,eAAA;AAtDJ;AAyDE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAvDJ;;AA2DA;EACE,mBAAA;AAxDF;AA0DE;EACE,cAAA;AAxDJ;;AA6DE;EACE,cAAA;AA1DJ;;AA8DA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,uBAAA;EACA,gCAAA;EACA,6DAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,SAAA;EACA,cAAA;EACA,eAAA;AA3DF;;AA8DA;EACE,uBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,qDAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3DF;AA6DE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA3DJ;AA8DE;;EAEE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;AA5DJ;AA8DI;;EACE,qBAAA;EACA,8CAAA;AA3DN;;AAgEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,0DAAA;AA7DF;AA+DE;EAEE,qBAAA;EACA,8CAAA;AA9DJ;;AAkEA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;AA/DF;;AAkEA;EACE,cAAA;EACA,eAAA;AA/DF;;AAkEA;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA/DF;AAiEE;EACE,qBAAA;EACA,mBAAA;AA/DJ;AAkEE;EACE,cAAA;EACA,eAAA;AAhEJ;;AAoEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AAjEF;AAmEE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjEJ;AAoEE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAlEJ;;AAsEA;EACE,0BAAA;EACA,mBAAA;EACA,6DAAA;AAnEF;;AAsEA;EACE,mBAAA;AAnEF;AAqEE;EACE,eAAA;EACA,cAAA;AAnEJ;;AAuEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApEF;;AAuEA;EACE,aAAA;EACA,0CAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AApEF;;AAuEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AApEF;;AAuEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AApEF;;AAuEA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AApEF;;AAuEA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AApEF;;AAuEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AApEF;AAsEE;EACE,cAAA;AApEJ;;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AArEF;;AAwEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AArEF;;AAwEA;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uDAAA;AArEF;;AAwEA;EACE,6DAAA;EACA,WAAA;EACA,+CAAA;AArEF;;AAwEA;EACE,6DAAA;EACA,WAAA;EACA,+CAAA;AArEF;;AAwEA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AArEF;;AAwEA;EACE,2BAAA;AArEF;;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;AArEF;;AAwEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AArEF;;AAwEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArEF;;AAwEA;EACE,oCAAA;AArEF;;AAwEA;EACE;IACE,uBAAA;EArEF;EAwEA;IACE,yBAAA;EAtEF;AACF;AAyEA;EACE;IACE,gCAAA;EAvEF;EA0EA;IACE,iCAAA;EAxEF;AACF;AA2EA;EACE;IACE,gDAAA;EAzEF;AACF;AA4EA;EACE;IACE,0DAAA;EA1EF;EA6EA;IACE,iBAAA;IACA,WAAA;EA3EF;EA8EA;IACE,gDAAA;EA5EF;EA+EA;IACE,WAAA;EA7EF;AACF;AAgFA;EACE;IACE,uBAAA;EA9EF;EAiFA;IACE,sBAAA;IACA,uBAAA;EA/EF;EAkFA;IACE,0BAAA;EAhFF;EAmFA;;;IAGE,sBAAA;IACA,uBAAA;EAjFF;EAoFA;IACE,2BAAA;IACA,YAAA;EAlFF;EAqFA;IACE,2BAAA;IACA,oBAAA;EAnFF;EAsFA;IACE,2BAAA;EApFF;AACF;AAuFA;EACE;IACE,gBAAA;IACA,SAAA;EArFF;EAwFA;IACE,qCAAA;IACA,SAAA;IACA,kBAAA;EAtFF;EAyFA;;;IAGE,WAAA;IACA,YAAA;EAvFF;EA0FA;;;IAGE,YAAA;EAxFF;EA2FA;IACE,YAAA;IACA,uBAAA;EAzFF;EA4FA;IACE,iBAAA;EA1FF;EA6FA;IACE,qBAAA;IACA,WAAA;IACA,eAAA;EA3FF;AACF;AA8FA;EACE;IACE,kBAAA;EA5FF;EA+FA;IACE,0BAAA;EA7FF;EAgGA;IACE,0BAAA;IACA,aAAA;EA9FF;EAiGA;;IAEE,kBAAA;IACA,mBAAA;EA/FF;EAkGA;;IAEE,kBAAA;IACA,mBAAA;EAhGF;EAmGA;IACE,cAAA;EAjGF;EAoGA;IACE,WAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;EAlGF;AACF;AAqGA;EACE;IACE,wBAAA;EAnGF;EAsGA;IACE,eAAA;EApGF;EAuGA;IACE,aAAA;IACA,aAAA;IACA,SAAA;IACA,mBAAA;EArGF;EAwGA;IACE,QAAA;EAtGF;EAyGA;IACE,aAAA;IACA,SAAA;EAvGF;EA0GA;;IAEE,eAAA;EAxGF;EA2GA;IACE,eAAA;EAzGF;EA4GA;IACE,QAAA;EA1GF;EA6GA;IACE,iBAAA;EA3GF;EA8GA;IACE,SAAA;EA5GF;EA+GA;;IAEE,eAAA;EA7GF;EAgHA;IACE,cAAA;IACA,YAAA;EA9GF;EAiHA;IACE,cAAA;IACA,eAAA;EA/GF;EAkHA;IACE,eAAA;IACA,kBAAA;IACA,gBAAA;EAhHF;AACF;AAmHA;EACE;IACE,aAAA;EAjHF;EAoHA;IACE,kBAAA;IACA,mBAAA;IACA,eAAA;EAlHF;EAqHA;IACE,kBAAA;IACA,mBAAA;EAnHF;EAsHA;IACE,iBAAA;IACA,kBAAA;EApHF;EAuHA;IACE,aAAA;IACA,aAAA;EArHF;EAwHA;IACE,sBAAA;IACA,uBAAA;IACA,aAAA;EAtHF;EAyHA;IACE,WAAA;IACA,eAAA;EAvHF;EA0HA;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;EAxHF;EA2HA;IACE,uBAAA;IACA,eAAA;EAzHF;EA4HA;IACE,eAAA;EA1HF;EA6HA;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EA3HF;EA8HA;IACE,oBAAA;IACA,gBAAA;IACA,UAAA;EA5HF;AACF","sourcesContent":[".jl-bg {\n  min-height: 100vh;\n  background: linear-gradient(180deg, #f7fbff 0%, #f4f7fb 100%);\n  overflow-x: clip;\n\n  &,\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n}\n\n.jl-container {\n  max-width: 1380px;\n  margin: 0 auto;\n  padding: 28px 24px 48px;\n}\n\n.jl-page-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.jl-page-shell--status {\n  gap: 20px;\n}\n\n.jl-page-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 8px 0 4px;\n}\n\n.jl-page-head--compact {\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0;\n  min-height: 20px;\n}\n\n.jl-page-head--status {\n  align-items: flex-start;\n}\n\n.jl-page-kicker {\n  margin: 0 0 10px;\n  color: #0f9f97;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.jl-page-title {\n  margin: 0;\n  color: #0f172a;\n  font-size: clamp(28px, 4vw, 40px);\n  font-weight: 800;\n  line-height: 1.08;\n  max-width: 760px;\n}\n\n.jl-page-subtitle {\n  margin: 12px 0 0;\n  max-width: 760px;\n  color: #64748b;\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.jl-result-count {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.jl-inline-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 14px 16px;\n  border: 1px solid #d7e7f4;\n  border-radius: 14px;\n  background: #f8fbff;\n  color: #355070;\n\n  svg {\n    flex: 0 0 auto;\n    margin-top: 2px;\n    font-size: 16px;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.6;\n  }\n}\n\n.jsb-wrap {\n  background: #fff;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n  margin-bottom: 0;\n  position: sticky;\n  top: 76px;\n  z-index: 20;\n}\n\n.jsb-inner {\n  max-width: 1380px;\n  margin: 0 auto;\n  padding: 18px 24px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(220px, 280px) auto;\n  gap: 14px;\n  align-items: center;\n}\n\n.jsb-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.jsb-input-icon {\n  position: absolute;\n  left: 16px;\n  color: #94a3b8;\n  font-size: 17px;\n  pointer-events: none;\n}\n\n.jsb-input {\n  width: 100%;\n  height: 54px;\n  padding: 0 18px 0 46px;\n  border: 1px solid #d9e2ec;\n  border-radius: 14px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n\n  &:focus {\n    border-color: #2ec4b6;\n    box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);\n  }\n}\n\n.city-dd {\n  position: relative;\n\n  &__control {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    height: 54px;\n    padding: 0 14px;\n    border: 1px solid #d9e2ec;\n    border-radius: 14px;\n    background: #fff;\n    transition: border-color 0.18s ease, box-shadow 0.18s ease;\n\n    &:focus-within {\n      border-color: #2ec4b6;\n      box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);\n    }\n  }\n\n  &__icon {\n    color: #94a3b8;\n    font-size: 16px;\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  &__input {\n    flex: 1 1 auto;\n    min-width: 0;\n    border: none;\n    outline: none;\n    font-size: 14px;\n    color: #0f172a;\n    background: transparent;\n\n    &::placeholder {\n      color: #9aa8b7;\n    }\n  }\n\n  &__clear,\n  &__arrow {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background: transparent;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 0;\n    flex: 0 0 auto;\n  }\n\n  &__clear {\n    font-size: 14px;\n  }\n\n  &__arrow {\n    font-size: 15px;\n    transition: transform 0.2s ease;\n  }\n\n  &__arrow--open {\n    transform: rotate(180deg);\n  }\n\n  &__menu {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    right: 0;\n    max-height: 280px;\n    overflow-y: auto;\n    margin: 0;\n    padding: 8px 0;\n    list-style: none;\n    background: #fff;\n    border: 1px solid #d9e2ec;\n    border-radius: 14px;\n    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.14);\n    z-index: 30;\n  }\n\n  &__item {\n    padding: 10px 14px;\n    color: #334155;\n    font-size: 14px;\n    cursor: pointer;\n\n    &:hover {\n      background: #f0fdfa;\n    }\n  }\n\n  &__item--active {\n    background: #e6fffb;\n    color: #0f766e;\n    font-weight: 700;\n  }\n\n  &__empty {\n    padding: 12px 14px;\n    color: #94a3b8;\n    font-size: 13px;\n    text-align: center;\n  }\n}\n\n.jsb-btn {\n  height: 54px;\n  padding: 0 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: none;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #17b9af 0%, #109d95 100%);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n\n  &:hover:not(:disabled) {\n    transform: translateY(-1px);\n    box-shadow: 0 10px 24px rgba(23, 185, 175, 0.26);\n  }\n\n  &:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n  }\n}\n\n.jl-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.job-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #dce7ef;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    border-color: #c9dbe6;\n    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);\n  }\n\n  &--compact {\n    align-self: start;\n    gap: 8px;\n\n    .job-card__content {\n      flex: 0 1 auto;\n      gap: 6px;\n    }\n\n    .job-card__footer {\n      padding-top: 6px;\n    }\n  }\n\n  &__content {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n    border: none;\n    background: transparent;\n    padding: 0;\n    text-align: left;\n    cursor: pointer;\n  }\n\n  &__header {\n    min-height: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  &__title {\n    flex: 1 1 auto;\n    min-width: 0;\n    margin: 0;\n    color: #0f172a;\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 1.28;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    overflow-wrap: anywhere;\n  }\n\n  &__location,\n  &__posted,\n  &__meta-item {\n    margin: 0;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: #64748b;\n    font-size: 13px;\n    line-height: 1.55;\n    min-width: 0;\n\n    svg {\n      flex: 0 0 auto;\n      font-size: 14px;\n    }\n\n    span {\n      min-width: 0;\n      overflow-wrap: anywhere;\n    }\n  }\n\n  &__salary {\n    margin: 0;\n    color: #f59e0b;\n    font-size: 21px;\n    font-weight: 800;\n    line-height: 1.2;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 7px;\n    min-width: 0;\n  }\n\n  &__type-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 7px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  &__type-badge--teal {\n    background: #dff8f5;\n    color: #0f766e;\n  }\n\n  &__type-badge--amber {\n    background: #fff4d6;\n    color: #b45309;\n  }\n\n  &__type-badge--slate {\n    background: #eef2f7;\n    color: #475569;\n  }\n\n  &__footer {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding-top: 6px;\n    border-top: 1px solid #edf2f7;\n    min-width: 0;\n  }\n\n  &__detail-link {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border: none;\n    background: transparent;\n    color: #0f9f97;\n    font-size: 14px;\n    font-weight: 700;\n    white-space: nowrap;\n    cursor: pointer;\n\n    &:hover {\n      color: #0d817b;\n    }\n  }\n\n  &__applied-badge {\n    flex: 0 0 auto;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 34px;\n    padding: 7px 11px;\n    border-radius: 999px;\n    background: #e7fbf3;\n    color: #166534;\n    border: 1px solid #b7efcd;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  &--skeleton {\n    pointer-events: none;\n    min-height: 238px;\n\n    .skeleton {\n      background: linear-gradient(90deg, #eef2f7 25%, #e4eaf1 50%, #eef2f7 75%);\n      background-size: 200% 100%;\n      animation: shimmer 1.5s infinite;\n      border-radius: 10px;\n    }\n\n    .skeleton--title {\n      height: 24px;\n      width: 70%;\n    }\n\n    .skeleton--text {\n      height: 14px;\n      width: 92%;\n    }\n\n    .skeleton--short {\n      width: 56%;\n    }\n\n    .skeleton--badge {\n      height: 34px;\n      width: 120px;\n      border-radius: 999px;\n    }\n\n    .skeleton-row {\n      display: flex;\n      gap: 10px;\n    }\n  }\n}\n\n.jl-list-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0 0;\n}\n\n.jl-load-sentinel {\n  width: 100%;\n  height: 1px;\n  pointer-events: none;\n}\n\n.jl-list-footer__loading,\n.jl-list-footer__end,\n.jl-list-footer__error {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-radius: 14px;\n  font-size: 14px;\n}\n\n.jl-list-footer__complete {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.jl-list-footer__loading {\n  color: #0f766e;\n  background: #e8fffa;\n  border: 1px solid #c8f6ed;\n}\n\n.jl-list-footer__end {\n  color: #64748b;\n  padding: 0;\n  background: transparent;\n  border: none;\n}\n\n.jl-list-footer__error {\n  color: #9f1239;\n  background: #fff1f4;\n  border: 1px solid #fecdd3;\n  flex-wrap: wrap;\n  justify-content: center;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border: none;\n    background: transparent;\n    color: #be123c;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n}\n\n.jl-back-to-top {\n  position: fixed;\n  right: 28px;\n  bottom: 124px;\n  z-index: 25;\n  width: 46px;\n  height: 46px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50%;\n  background: #0f9f97;\n  color: #fff;\n  box-shadow: 0 12px 28px rgba(15, 118, 110, 0.3);\n  font-size: 23px;\n  cursor: pointer;\n  transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n\n  &:hover {\n    background: #0d817b;\n    box-shadow: 0 16px 34px rgba(15, 118, 110, 0.38);\n    transform: translateY(-4px);\n  }\n\n  &:focus-visible {\n    outline: 2px solid #2ec4b6;\n    outline-offset: 3px;\n  }\n}\n\n.jl-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 300px;\n  padding: 36px 28px;\n  border: 1px solid #dce7ef;\n  border-radius: 22px;\n  background: #fff;\n  text-align: center;\n\n  svg {\n    font-size: 40px;\n    color: #0f9f97;\n  }\n\n  p {\n    margin: 0;\n    color: #334155;\n    font-size: 16px;\n    line-height: 1.65;\n    max-width: 720px;\n  }\n\n  .jl-state__sub {\n    color: #64748b;\n    font-size: 14px;\n  }\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 4px;\n    min-height: 46px;\n    padding: 0 18px;\n    border: none;\n    border-radius: 12px;\n    background: linear-gradient(135deg, #17b9af 0%, #109d95 100%);\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    cursor: pointer;\n  }\n}\n\n.jl-state--error {\n  background: #fff9fa;\n\n  svg {\n    color: #e11d48;\n  }\n}\n\n.jl-state--loading {\n  svg {\n    color: #0f9f97;\n  }\n}\n\n.jl-status {\n  border: 1px solid #dbe7f0;\n  border-radius: 24px;\n  background: #fff;\n  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.jl-status__header {\n  padding: 24px 28px 18px;\n  border-bottom: 1px solid #e8eff5;\n  background: linear-gradient(180deg, #fcfffe 0%, #f8fbff 100%);\n}\n\n.jl-status__header-title {\n  margin: 0 0 4px;\n  color: #0f172a;\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.jl-status__count {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.jl-status__table-wrap {\n  padding: 22px 28px 28px;\n}\n\n.jl-status__filters {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;\n  gap: 12px;\n  align-items: end;\n  padding: 16px;\n  margin-bottom: 18px;\n  border: 1px solid #e6edf3;\n  border-radius: 18px;\n  background: #fbfdfe;\n}\n\n.jl-status-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  label {\n    margin: 0;\n    color: #475569;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  select,\n  input {\n    height: 46px;\n    padding: 0 14px;\n    border: 1px solid #dbe4ea;\n    border-radius: 12px;\n    background: #fff;\n    color: #0f172a;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.18s ease, box-shadow 0.18s ease;\n\n    &:focus {\n      border-color: #2ec4b6;\n      box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);\n    }\n  }\n}\n\n.jl-status-filter__calendar-trigger {\n  height: 46px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0 14px;\n  border: 1px solid #dbe4ea;\n  border-radius: 12px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n\n  &:focus,\n  &:focus-visible {\n    border-color: #2ec4b6;\n    box-shadow: 0 0 0 4px rgba(46, 196, 182, 0.12);\n  }\n}\n\n.jl-status-filter__calendar-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.jl-status-filter__calendar-caret {\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.jl-status__reset-filter {\n  height: 46px;\n  padding: 0 16px;\n  border: 1px solid #d7e7f4;\n  border-radius: 12px;\n  background: #f8fbff;\n  color: #0f766e;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n\n  &:hover {\n    border-color: #99d9d3;\n    background: #eefbf9;\n  }\n\n  svg {\n    flex: 0 0 auto;\n    font-size: 15px;\n  }\n}\n\n.jl-status__guest {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 260px;\n  padding: 32px;\n  text-align: center;\n\n  h3 {\n    margin: 0 0 8px;\n    color: #0f172a;\n    font-size: 20px;\n    font-weight: 800;\n  }\n\n  p {\n    margin: 0;\n    color: #64748b;\n    font-size: 14px;\n    line-height: 1.7;\n    max-width: 640px;\n  }\n}\n\n.jl-status__guest--filtered {\n  border: 1px dashed #cbd5e1;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #fbfdfe 0%, #f8fafc 100%);\n}\n\n.jl-status__guest-icon {\n  margin-bottom: 12px;\n\n  svg {\n    font-size: 40px;\n    color: #0f9f97;\n  }\n}\n\n.jl-app-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.jl-app-card {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: stretch;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n}\n\n.jl-app-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  min-width: 0;\n  padding: 14px 16px;\n}\n\n.jl-app-card__title-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.jl-app-card__headline {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-width: 0;\n}\n\n.jl-app-card__title {\n  margin: 0;\n  color: #0f172a;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.3;\n}\n\n.jl-app-card__meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.jl-app-card__meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.35;\n\n  svg {\n    flex: 0 0 auto;\n  }\n}\n\n.jl-app-card__side {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-width: 260px;\n}\n\n.jl-status__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 9px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.jl-status__badge--success {\n  background: #e7fbf3;\n  color: #166534;\n  border: 1px solid #b7efcd;\n}\n\n.jl-status__badge--info {\n  background: #e9f3ff;\n  color: #1d4ed8;\n  border: 1px solid #bfd9ff;\n}\n\n.jl-status__badge--danger {\n  background: #fff1f4;\n  color: #be123c;\n  border: 1px solid #fecdd3;\n}\n\n.jl-status__badge--warning {\n  background: #fff7e4;\n  color: #b45309;\n  border: 1px solid #fde68a;\n}\n\n.jl-app-card__ai {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 14px 16px 14px 0;\n  background: transparent;\n}\n\n.jl-app-card__ai-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.jl-app-card__ai-title {\n  color: #0f172a;\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.jl-app-card__ai-desc,\n.jl-app-card__ai-meta-row {\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.jl-app-card__ai-cta {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.jl-iv-flow {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.jl-iv-flow--not_started {\n  background: #fff7e4;\n  color: #b45309;\n  border: 1px solid #fde68a;\n}\n\n.jl-iv-flow--in_progress {\n  background: #e9f3ff;\n  color: #1d4ed8;\n  border: 1px solid #bfd9ff;\n}\n\n.jl-iv-flow--completed {\n  background: #e7fbf3;\n  color: #166534;\n  border: 1px solid #b7efcd;\n}\n\n.jl-iv-btn {\n  min-height: 38px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.jl-iv-btn--start {\n  background: linear-gradient(135deg, #17b9af 0%, #109d95 100%);\n  color: #fff;\n  box-shadow: 0 10px 22px rgba(23, 185, 175, 0.2);\n}\n\n.jl-iv-btn--resume {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: #fff;\n  box-shadow: 0 10px 22px rgba(59, 130, 246, 0.2);\n}\n\n.jl-iv-btn--detail {\n  border: 1px solid #c8d7e3;\n  background: #fff;\n  color: #0f172a;\n}\n\n.jl-iv-btn:hover {\n  transform: translateY(-1px);\n}\n\n.jl-iv-result {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n}\n\n.jl-iv-result__score-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.jl-iv-result__score {\n  color: #0f172a;\n  font-size: 15px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.jl-iv-result__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: #edf4ff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.spin {\n  animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% center;\n  }\n\n  100% {\n    background-position: -200% center;\n  }\n}\n\n@media (max-width: 1260px) {\n  .jl-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1120px) {\n  .jsb-inner {\n    grid-template-columns: minmax(0, 1fr) minmax(220px, 260px);\n  }\n\n  .jsb-btn {\n    grid-column: 1 / -1;\n    width: 100%;\n  }\n\n  .jl-status__filters {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .jl-status__reset-filter {\n    width: 100%;\n  }\n}\n\n@media (max-width: 900px) {\n  .jl-container {\n    padding: 20px 16px 36px;\n  }\n\n  .jl-page-head {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .jl-app-card {\n    grid-template-columns: 1fr;\n  }\n\n  .jl-app-card__header,\n  .jl-app-card__ai-top,\n  .jl-iv-result {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .jl-app-card__side {\n    justify-content: flex-start;\n    min-width: 0;\n  }\n\n  .jl-app-card__ai {\n    justify-content: flex-start;\n    padding: 0 16px 14px;\n  }\n\n  .jl-app-card__ai-cta {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 820px) {\n  .jsb-wrap {\n    position: static;\n    top: auto;\n  }\n\n  .jsb-inner {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 10px;\n    padding: 14px 16px;\n  }\n\n  .jsb-input-wrap,\n  .city-dd,\n  .jsb-btn {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .jsb-input,\n  .city-dd__control,\n  .jsb-btn {\n    height: 50px;\n  }\n\n  .jsb-input {\n    min-width: 0;\n    text-overflow: ellipsis;\n  }\n\n  .jsb-btn {\n    grid-column: auto;\n  }\n\n  .jl-container {\n    padding-bottom: 126px;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 720px) {\n  .jsb-inner {\n    padding: 12px 16px;\n  }\n\n  .jl-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .jl-status__filters {\n    grid-template-columns: 1fr;\n    padding: 14px;\n  }\n\n  .jl-status__table-wrap,\n  .jl-status__header {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .jl-app-card__header,\n  .jl-app-card__ai {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .jl-app-card__ai {\n    padding-top: 0;\n  }\n\n  .jl-back-to-top {\n    right: 78px;\n    bottom: 18px;\n    width: 44px;\n    height: 44px;\n  }\n}\n\n@media (max-width: 560px) {\n  .jl-container {\n    padding: 16px 12px 126px;\n  }\n\n  .jl-page-title {\n    font-size: 28px;\n  }\n\n  .job-card {\n    min-height: 0;\n    padding: 16px;\n    gap: 10px;\n    border-radius: 16px;\n  }\n\n  .job-card__content {\n    gap: 8px;\n  }\n\n  .job-card__header {\n    min-height: 0;\n    gap: 10px;\n  }\n\n  .job-card__title,\n  .jl-app-card__title {\n    font-size: 18px;\n  }\n\n  .job-card__salary {\n    font-size: 19px;\n  }\n\n  .job-card__meta {\n    gap: 7px;\n  }\n\n  .job-card__type-badge {\n    padding: 7px 10px;\n  }\n\n  .job-card__footer {\n    gap: 10px;\n  }\n\n  .job-card__posted,\n  .job-card__meta-item {\n    font-size: 12px;\n  }\n\n  .job-card__posted {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .job-card__detail-link {\n    flex: 0 0 auto;\n    font-size: 13px;\n  }\n\n  .jl-list-footer__end {\n    max-width: 100%;\n    text-align: center;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 360px) {\n  .jsb-inner {\n    padding: 10px;\n  }\n\n  .jsb-input {\n    padding-left: 42px;\n    padding-right: 12px;\n    font-size: 14px;\n  }\n\n  .city-dd__control {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .jl-container {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .job-card {\n    min-height: 0;\n    padding: 14px;\n  }\n\n  .job-card__header {\n    flex-direction: column;\n    align-items: flex-start;\n    min-height: 0;\n  }\n\n  .job-card__title {\n    width: 100%;\n    font-size: 17px;\n  }\n\n  .job-card__applied-badge {\n    min-height: 30px;\n    padding: 6px 9px;\n    font-size: 11px;\n  }\n\n  .job-card__location {\n    align-items: flex-start;\n    font-size: 12px;\n  }\n\n  .job-card__salary {\n    font-size: 18px;\n  }\n\n  .job-card__footer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .job-card__detail-link {\n    align-self: flex-end;\n    min-height: 36px;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
